<template lang="html">
    <div id="meetInfo" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <meetBar v-if="meetBarOnOff" :tags="tags" :data="data" :btnSave="false" :btnBack="true" :btnAgree="false"
            :btnRefuse="false" :btnSubmit="false" :complete="false" :btnDelete="false"
            @btnBackClick="handleBackClick" />
        <div style="width: 550px;display: none;" id="htmlPdf">
            <div class="pdf-group" style="padding-top: 10px;margin-top: 12px; ">
                <div style="font-weight: bold;font-size: 20px; text-align: center;">{{meetInfo.subject}}</div>
                <el-row style="margin-top:40px">
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">营销项目</el-col>
                    <el-col :span="7"
                        style="font-size: 14px;color: #4A90E2;padding-left:2%; border:1px solid transparent">
                        {{meetInfo.project_name}}
                    </el-col>
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">所属辖区</el-col>
                    <el-col :span="8"
                        style="font-size: 14px;color: #4A90E2;padding-left:2%; border:1px solid transparent">
                        {{meetInfo.territory_name}}
                    </el-col>
                </el-row>
                <el-row style="margin-top:18px">
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">主题</el-col>
                    <el-col :span="7" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        {{meetInfo.subject}}</el-col>
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">会议日期</el-col>
                    <el-col :span="8" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        {{meetInfo.activity_date}}</el-col>
                </el-row>
                <el-row style="margin-top:18px">
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">开始时间</el-col>
                    <el-col :span="7" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        {{meetInfo.start_time|timeFormat}}</el-col>
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">结束时间</el-col>
                    <el-col :span="8" style="color: #4A90E2;font-size: 14px;padding-left:2%;">
                        {{meetInfo.end_time|timeFormat}}</el-col>
                </el-row>
                <el-row style="margin-top:18px">
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">产品</el-col>
                    <el-col :span="7" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        <el-tag style="margin-right: 5px;margin-bottom:5px;" v-for="item in meetInfo.productArray"
                            :key="item.product_id" type="warning" effect="dark" size="mini">
                            {{ item.product_name }}
                        </el-tag>
                        &nbsp;
                    </el-col>
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">类型</el-col>
                    <el-col :span="8" style="font-size: 14px;color: #4A90E2;padding-left:2%;
                            border:1px solid transparent">
                        {{meetInfo.meeting_type_value}}</el-col>
                </el-row>
                <el-row style="margin-top:18px">
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">讲者人数</el-col>
                    <el-col :span="7" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        {{meetInfo.speakerArray.length }}</el-col>
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">线上参会人数</el-col>
                    <el-col :span="8" style="color: #4A90E2;font-size: 14px;padding-left:2%;">
                        {{meetInfo.audienceArray_take.length }}</el-col>
                </el-row>
                <el-row style="margin-top:18px">
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">创建者</el-col>
                    <el-col :span="7" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        {{meetInfo.alias }}</el-col>
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">协办人</el-col>
                    <el-col :span="8" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        <el-tag style="margin-right: 5px;margin-bottom:5px;" v-for="item in meetInfo.teamArray"
                            :key="item.user_id" type="warning" effect="dark" size="mini">
                            {{ item.alias }}
                        </el-tag>
                    </el-col>
                </el-row>
                <el-row style="margin-top:10px" v-show="isshow_checkin_time">
                    <el-col :span="4" style="font-size: 14px;font-weight: bold">扫码签到人数</el-col>
                    <el-col :span="7" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                        {{meetInfo.checkin_time_count }}</el-col>
                </el-row>
                <div style="margin-top: 40px;font-size: 14px;font-weight: bold">
                    线上参会讲者
                </div>
                <el-table :header-cell-style="{'color':'black','font-size':'12px'}" :cell-style="{'font-size':'12px'}"
                    :data="meetInfo.speakerArray" border style="width: 100%;margin-top: 18px;" stripe>
                    <el-table-column align="center" type="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column width="260" prop="institution" label="所在机构">
                    </el-table-column>
                    <el-table-column width="140" prop="speaker_name" label="讲者姓名">
                    </el-table-column>
                    <el-table-column width="99" label="参会时长">
                        <template slot-scope="scope">
                            {{ getShowDuration(scope.row) }}
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 40px;font-size: 14px;font-weight: bold">
                    线上参会人员
                </div>
                <el-table :header-cell-style="{'color':'black','font-size':'12px'}" :cell-style="{'font-size':'12px'}"
                    :data="meetInfo.audienceArray_take" border style="width: 100%;margin-top: 18px;" stripe
                    v-show="isshow_checkin_time">
                    <el-table-column align="center" type="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column width="140" prop="institution_name" label="机构名称">
                    </el-table-column>
                    <el-table-column width="80" prop="hcp_name" label="姓名">
                    </el-table-column>
                    <el-table-column width="90" prop="pro_title" label="职称">
                    </el-table-column>
                    <el-table-column width="110" label="扫码签到时间">
                        <template slot-scope="scope">
                            {{ scope.row.checkin_time |timeFormat2}}
                        </template>
                    </el-table-column>
                    <el-table-column width="99" label="参会时长">
                        <template slot-scope="scope">
                            {{ getShowDuration(scope.row) }}
                        </template>
                    </el-table-column>
                </el-table>
                <el-table :header-cell-style="{'color':'black','font-size':'12px'}" :cell-style="{'font-size':'12px'}"
                    :data="meetInfo.audienceArray_take" border style="width: 100%;margin-top: 18px;" stripe
                    v-show="!isshow_checkin_time">
                    <el-table-column align="center" type="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column width="170" prop="institution_name" label="机构名称">
                    </el-table-column>
                    <el-table-column width="110" prop="hcp_name" label="姓名">
                    </el-table-column>
                    <el-table-column width="120" prop="pro_title" label="职称">
                    </el-table-column>
                    <el-table-column width="129" label="参会时长">
                        <template slot-scope="scope">
                            {{ getShowDuration(scope.row) }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pdf-group">
                <div style="margin-top:18px">
                    <el-row>
                        <el-col :span="6" style="font-size: 14px;font-weight: bold;">线下会议室</el-col>
                        <el-col :span="16" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                            <el-tag style="margin-right: 5px;margin-bottom:5px;" v-for="item in meetInfo.roomArray"
                                :key="item.key_id" type="warning" effect="dark" size="mini">
                                {{ item.room_name }}
                            </el-tag>
                        </el-col>
                    </el-row>
                </div>
                <div style="margin-top:18px" v-for="(item,j) in meetInfo.roomArray">
                    <div style="font-size: 14px;font-weight: bold;">线下会议室-{{item.room_name}}
                    </div>
                    <div :span="24" style="font-size: 14px;color: #4A90E2;margin-top: 12px; ">
                        <div :class="j=='0'?'':'pdf-split-page'" v-for="(sub_item,j) in item.photosList">
                            <el-image :src="sub_item.url" crossOrigin="anonymous"
                                style="width: 550px;max-height: 700px;">
                            </el-image>
                            <div class="demonstration" style="text-align: center;margin-bottom: 10px; ">
                                {{sub_item.title}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pdf-group">
                <div style="margin-top: 40px;font-size: 14px;font-weight: bold">
                    内部人员
                </div>
                <el-table :header-cell-style="{'color':'black','font-size':'12px'}" :cell-style="{'font-size':'12px'}"
                    :data="meetInfo.timeframeArray_take" border style="width: 100%;margin-top: 18px;"
                    class="ant-table-row" stripe>
                    <el-table-column align="center" type="index" label="序号" width="60px">
                    </el-table-column>
                    <el-table-column width="300" label="部门">
                        <template slot-scope="scope">
                            {{ getShowOu(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column width="189" prop="nickname" label="姓名">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div style="height: 100%">
            <div style="width: 100%;float: left">
                <el-tabs v-model="activeName" id="tabs_meetinfg">
                    <!-- 会议总结-->
                    <el-tab-pane label="会议总结" name="summary">
                        <div class="message" style="margin-top: 20px;">
                            <el-form ref="formSumarray" :model="meetInfo">
                                <el-row style="margin-top:18px">
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">营销项目</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;
                                    border:1px solid transparent">
                                        {{meetInfo.project_name}}</el-col>
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">所属辖区</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;
                                        border:1px solid transparent">
                                        {{meetInfo.territory_name}}</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #FF9901;
                                    cursor: pointer;text-align: right">
                                        <el-button type="primary" icon="el-icon-download" @click.stop="exportPDF"
                                            size="small">导出总结
                                        </el-button>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">主题</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        {{meetInfo.subject}}</el-col>
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">会议日期</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        {{meetInfo.activity_date}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">开始时间</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        {{meetInfo.start_time|timeFormat}}</el-col>
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">结束时间</el-col>
                                    <el-col :span="6" style="color: #4A90E2;font-size: 14px;padding-left:2%;">
                                        {{meetInfo.end_time|timeFormat}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">产品</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        <el-tag style="margin-right: 5px;margin-bottom:5px;"
                                            v-for="item in meetInfo.productArray" :key="item.product_id" type="warning"
                                            effect="dark" size="mini">
                                            {{ item.product_name }}
                                        </el-tag>
                                        &nbsp;
                                    </el-col>
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">类型</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;
                                    border:1px solid transparent">
                                        {{meetInfo.meeting_type_value}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">讲者人数</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        {{meetInfo.speakerArray.length }}</el-col>
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">线上参会人数</el-col>
                                    <el-col :span="6" style="color: #4A90E2;font-size: 14px;padding-left:2%;">
                                        {{meetInfo.audienceArray_take.length }}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">创建者</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        {{meetInfo.alias }}</el-col>
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">协办人</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        <el-tag style="margin-right: 5px;margin-bottom:5px;"
                                            v-for="item in meetInfo.teamArray" :key="item.user_id" type="warning"
                                            effect="dark" size="mini">
                                            {{ item.alias }}
                                        </el-tag>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:18px" v-show="isshow_checkin_time">
                                    <el-col :span="3" style="font-size: 14px;font-weight: bold">扫码签到人数</el-col>
                                    <el-col :span="6" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                        {{meetInfo.checkin_time_count }}</el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <div style="margin-top: 40px;font-size: 14px;font-weight: bold">
                            线上参会讲者
                        </div>
                        <el-table :header-cell-style="{'color':'black','font-size':'12px'}" :cell-style="{'font-size':'12px'}"
                            :data="meetInfo.speakerArray" border style="width: 100%;margin-top: 18px;" stripe>
                            <el-table-column align="center" type="index" label="序号" width="60">
                            </el-table-column>
                            <el-table-column width="280" prop="institution" label="所在机构">
                            </el-table-column>
                            <el-table-column width="180" prop="speaker_name" label="讲者姓名">
                            </el-table-column>
                            <el-table-column label="参会时长">
                                <template slot-scope="scope">
                                    {{ getShowDuration(scope.row) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="margin-top: 40px;font-size: 14px;font-weight: bold">
                            线上参会人员
                        </div>
                        <el-table :header-cell-style="{'color':'black','font-size':'15px'}"
                            :data="meetInfo.audienceArray_take" border style="width: 100%;margin-top: 18px;" stripe
                            v-show="isshow_checkin_time">
                            <el-table-column align="center" type="index" label="序号" width="60px">
                            </el-table-column>
                            <el-table-column width="420" prop="institution_name" label="机构名称">
                            </el-table-column>
                            <el-table-column width="220" prop="hcp_name" label="姓名">
                            </el-table-column>
                            <el-table-column width="220" prop="pro_title" label="职称">
                            </el-table-column>
                            <el-table-column width="220" label="扫码签到时间">
                                <template slot-scope="scope">
                                    {{ scope.row.checkin_time |timeFormat2}}
                                </template>
                            </el-table-column>
                            <el-table-column label="参会时长">
                                <template slot-scope="scope">
                                    {{ getShowDuration(scope.row) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table :header-cell-style="{'color':'black','font-size':'15px'}"
                            :data="meetInfo.audienceArray_take" border style="width: 100%;margin-top: 18px;" stripe
                            v-show="!isshow_checkin_time">
                            <el-table-column align="center" type="index" label="序号" width="60px">
                            </el-table-column>
                            <el-table-column width="480" prop="institution_name" label="机构名称">
                            </el-table-column>
                            <el-table-column width="280" prop="hcp_name" label="姓名">
                            </el-table-column>
                            <el-table-column width="280" prop="pro_title" label="职称">
                            </el-table-column>
                            <el-table-column label="参会时长">
                                <template slot-scope="scope">
                                    {{ getShowDuration(scope.row) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-row style="margin-top:18px">
                            <el-col :span="3" style="font-size: 14px;font-weight: bold;">线下会议室</el-col>
                            <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                <span v-for="(item,j) in meetInfo.roomArray"
                                    style="padding:2px 4px;
                                background: #FF9901;color: #ffffff;border-radius: 10%;margin-right: 5px;">{{item.room_name}}</span>
                                &nbsp;
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:18px" v-for="(item,j) in meetInfo.roomArray">
                            <el-col :span="3" style="font-size: 14px;font-weight: bold;">线下会议室-{{item.room_name}}
                            </el-col>
                            <el-col :span="16" style="font-size: 14px;color: #4A90E2;padding-left:2%;">
                                <span style="float:left; margin-right:10px" v-for="(sub_item,j) in item.photosList">
                                    <el-image :src="sub_item.url" style="width: 100px; height: 100px" fit="fill"
                                        :preview-src-list="[sub_item.url]">
                                        <div slot="placeholder" class="image-slot">
                                            加载中<span class="dot">...</span>
                                        </div>
                                    </el-image>
                                    <div class="demonstration">{{sub_item.title}}</div>
                                </span>
                            </el-col>
                        </el-row>
                        <div style="margin-top: 40px;font-size: 14px;font-weight: bold">
                            内部人员
                        </div>
                        <el-table :header-cell-style="{'color':'black','font-size':'15px'}"
                            :data="meetInfo.timeframeArray_take" border style="width: 100%;margin-top: 18px;" stripe>
                            <el-table-column align="center" type="index" label="序号" width="60px">
                            </el-table-column>
                            <el-table-column width="420" label="部门">
                                <template slot-scope="scope">
                                    {{ getShowOu(scope.row) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="nickname" label="姓名">
                            </el-table-column>
                        </el-table>
                        <div style="height: 100px;"></div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>


        <div class="pdf-header" style="
                font-weight: bold;
                padding: 15px 8px;
                width: 100%;
                color: rgba(78, 78, 78, 0.85);
                position: fixed;
                top: -100vh;
                ">
            <div style="display: flex; justify-content: end; align-items: flex-end; ">
                打印时间:{{currentTime}}
            </div>
        </div>
        <div class="pdf-footer" style="
                font-weight: bold;
                padding: 15px 8px;
                width: 100%;
                position: fixed;
                top: -100vh;
                ">
            <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
                第
                <div class="pdf-footer-page"></div>
                页 / 共
                <div class="pdf-footer-page-count"></div>
                页
            </div>
        </div>
    </div>
</template>

<script>
    import meetBar from '../../../components/onlineMeetBar'
    import http from '../../../APIService/http'
    import { htmlToPdf } from '../../../tools/exportPdf'
    import { PdfLoader } from "../../../tools/pdfLoader";

    import moment from 'moment'
    export default {
        name: "onlinemeetting",
        data() {
            let self = this;
            return {
                currentTime: moment().format("YYYY-MM-DD HH:mm:ss"),
                loading: false,
                tags: ['辖区事务', '在线会议'],
                activeName: 'summary',
                departmentName: 'first',
                meetBarOnOff: false,
                isExport: false,
                activity_id: '',
                data: {

                },
                tableData: [],

                territoryArray: [],
                meetInfo: {
                    territory_name: "",
                    project_name: "",
                    subject: "",
                    activity_date: "",
                    start_time: "",
                    speakerArray: [],
                    audienceArray_take: [],
                    roomArray: [],
                    timeframeArray_take: []
                },
                isshow_checkin_time: false
            }
        },
        components: {
            meetBar
        },
        updated() {

        },
        filters: {
            componentFliter: function (value) {

                return moment(value).format('YYYY-MM-DD')
            },

            timeFormat: function (time) {
                return time?moment(time).format('YYYY年M月D日 HH:mm'):""
            },

            timeFormat2: function (time) {
                console.log(time)
                return time?moment(time).format('MM月DD日 HH:mm'):""
            }
        },
        watch: {

        },
        created() {
            if (Object.keys(this.$route.params).length === 0) {
                let condition = localStorage.getItem('condition')
                this.activity_id = JSON.parse(condition).activity_id
                this.init();
            } else {
                this.activity_id = this.$route.params.activity_id
                this.init();
            }

        },
        mounted() {
            this.getParametersList();
        },
        methods: {
            getParametersList() {
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id
                    }
                    http.post('/crm/other/parameters/getAllByTenantId', data).then((res) => {
                        console.log("-----------------------------")
                        debugger;
                        console.log(res);
                        this.$store.commit('setParameters', res.data)

                        let checkin_time_params = res.data.find(e => e.parameter_id === "ENABLE_ONLINE_MEETING_CHECKIN")
                        if (checkin_time_params && checkin_time_params.parameter_value === "T") {
                            this.isshow_checkin_time = true;
                        }
                    })
                } catch (e) { }
            },
            getShowDuration(row) {
                let str = parseInt(row.duration / 60);
                let str1 = row.duration % 60;
                if (str == 0 && str1 > 0) {
                    str = str1 + "秒";
                } else {
                    str = str + "分钟";
                    if (str1 > 0) {
                        str = str + str1 + "秒"
                    }
                }
                return str;
            },
            getShowOu(row) {
                console.log(row)
                let ouStr = ""
                for (const item of row.ou) {
                    if (ouStr != "") {
                        ouStr = ouStr + ",";
                    }
                    ouStr = ouStr + item.ou_name;
                }
                return ouStr;
            },
            async init(type) {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        activity_id: this.activity_id,
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                    }
                    await http.post('/echo/online/web/meeting/getMeetingByActivityId', data).then(res => {
                        if (res.success === true) {
                            this.meetBarOnOff = true

                            this.data = res.data
                            this.meetInfo = res.data
                            let audienceArray_take = [];
                            let checkin_time_count = 0;
                            for (const item of res.data.audienceArray) {
                                if (item.duration) {
                                    audienceArray_take.push(item);
                                }
                                if (item.checkin_time) {
                                    checkin_time_count = checkin_time_count + 1;
                                }
                            }
                            this.meetInfo.checkin_time_count = checkin_time_count;
                            this.meetInfo.audienceArray_take = audienceArray_take;

                            let timeframeArray_take = [];
                            for (const item of res.data.timeframeArray) {
                                if (item.institution_name == "内部人员") {
                                    timeframeArray_take.push(item);
                                }
                            }
                            this.meetInfo.timeframeArray_take = timeframeArray_take;

                            this.getRoomImgUrl();
                        }
                    })
                    loading.close()
                } catch (e) {
                    loading.close()
                    return e
                }
            },

            //获取线下会议室图片
            async getRoomImgUrl(photo_item) {

                try {
                    for (let room of this.meetInfo.roomArray) {
                        for (let photo of room.photosList) {
                            await this.downloadRoomPhoto(photo);
                        }
                    }

                    this.$forceUpdate()
                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            async downloadRoomPhoto(item) {

                try {
                    let data = {
                        photo_ids: item.photo_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data);
                    let array = res.data
                    if (array.length > 0) {
                        item.url = array[0].url;
                        item.title = array[0].title;
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            handleBackClick() {
                this.$router.go(-1)
            },
            async exportPDF() {
                // let isExtImg = false;
                // for (const roomItem of this.meetInfo.roomArray) {
                //     if (roomItem.photosList && roomItem.photosList.length > 0) {
                //         isExtImg = true;
                //     }
                // }

                // // htmlToPdf.getPdf(this.meetInfo.subject, "htmlPdf", isExtImg)
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const element = document.querySelector(`#htmlPdf`);
                element.style.display = "";
                const header = document.querySelector(".pdf-header");
                const footer = document.querySelector(".pdf-footer");
                // let data = {
                //     element: element,
                //     contentWidth: 550,
                //     footer: header,
                //     header: footer,
                //     filename: this.meetInfo.subject
                // }
                // debugger;
                // await htmlToPdf(data)
                const pdfLoader = new PdfLoader(element, {
                    footer: footer,
                    header: header,
                    fileName: this.meetInfo.subject,
                    direction: "p",
                    isPageMessage: true
                });
                pdfLoader.getPdf().then((res) => {
                    debugger
                    element.style.display = "none";
                    loading.close()
                    this.$message({
                        type: 'success',
                        message: '下载成功'
                    })
                });
            },
        }

    }
</script>

<style scoped>
    /*#meetInfo {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #council>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    #coordinates>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    #change>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    #agenda>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    #estimates>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    #speak>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    #actual>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    #pictureAdd>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }

    #AgendaAdd>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }

    #estimates>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }

    #estimates #meetInfo>>>.el-tag.el-tag--info {
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }
</style>


// WEBPACK FOOTER //
// src/pages/calendar/components/onlineMeetingInfo.vue